import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'gap-horizontal',
  size: 24,
  node: [
    ['path', { d: 'M12 2v2', key: 'tus03m' }],
    ['path', { d: 'M12 8v2', key: '1woqiv' }],
    ['path', { d: 'M12 14v2', key: '8jcxud' }],
    ['path', { d: 'M12 20v2', key: '1lh1kg' }],
    ['path', { d: 'M21 3h-3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h3', key: 'sixnkk' }],
    ['path', { d: 'M3 3h3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3', key: 'z694kp' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name GapHorizontal
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMnYyIiAvPgogIDxwYXRoIGQ9Ik0xMiA4djIiIC8+CiAgPHBhdGggZD0iTTEyIDE0djIiIC8+CiAgPHBhdGggZD0iTTEyIDIwdjIiIC8+CiAgPHBhdGggZD0iTTIxIDNoLTNhMiAyIDAgMCAwLTIgMnYxNGEyIDIgMCAwIDAgMiAyaDMiIC8+CiAgPHBhdGggZD0iTTMgM2gzYTIgMiAwIDAgMSAyIDJ2MTRhMiAyIDAgMCAxLTIgMkgzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/gap-horizontal
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const GapHorizontal = createLucideIcon(__iconData);

export default GapHorizontal;
